<ion-content class="ion-padding">
  <ion-refresher slot="fixed" (ionRefresh)="buscarDadosContrato($event)">
    <ion-refresher-content>
    </ion-refresher-content>
  </ion-refresher>

  <usucampeao-outros-documentos [dadosContrato]="dadosContrato" [contratoDocumento]="contratoDocumento"
    [procuracaoDocumento]="procuracaoDocumento" [comprovanteRendaDocumento]="comprovanteRendaDocumento"
    [alteracoes]="alteracoes$ | async"></usucampeao-outros-documentos>
</ion-content>